/* AMESCENSE — DIY theme. Vanilla JS, progressive enhancement.
   Everything degrades to a working native experience without JS. */
(function () {
  'use strict';

  var money = window.Shopify && window.Shopify.money_format ? window.Shopify.money_format : '${{amount}}';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    return money.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  /* -------- Mobile nav -------- */
  function initNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.getElementById('SiteNav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* -------- Ticker: duplicate content for a seamless loop -------- */
  function initTicker() {
    var track = document.querySelector('[data-ticker]');
    if (!track) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var item = track.querySelector('.ticker__item');
    if (!item) return;
    var reps = Math.ceil((window.innerWidth * 2) / (item.offsetWidth || 300)) + 1;
    var html = item.outerHTML;
    var buffer = '';
    for (var i = 0; i < reps; i++) buffer += html;
    track.innerHTML = buffer + buffer; // two identical halves -> translateX(-50%) loops cleanly
  }

  /* -------- Product: variant selection + gallery -------- */
  function initProduct() {
    var root = document.querySelector('[data-product]');
    if (!root) return;

    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var optionInputs = root.querySelectorAll('[data-option-input]');
    var variantIdField = root.querySelector('[data-variant-id]');
    var priceCurrent = root.querySelector('[data-price-current]');
    var priceCompare = root.querySelector('[data-price-compare]');
    var atc = root.querySelector('[data-atc]');
    var atcText = root.querySelector('[data-atc-text]');

    function selectedOptions() {
      var chosen = [];
      var groups = {};
      optionInputs.forEach(function (input) {
        if (input.checked) groups[input.name] = input.value;
      });
      Object.keys(groups).sort().forEach(function (k) { chosen.push(groups[k]); });
      return chosen;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function update() {
      var opts = selectedOptions();
      var variant = opts.length ? findVariant(opts) : variants[0];
      if (!variant) {
        if (atc) { atc.disabled = true; }
        if (atcText) atcText.textContent = 'UNAVAILABLE';
        return;
      }
      if (variantIdField) variantIdField.value = variant.id;
      if (priceCurrent) priceCurrent.textContent = formatMoney(variant.price);
      if (priceCompare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceCompare.textContent = formatMoney(variant.compare_at_price);
          priceCompare.hidden = false;
        } else {
          priceCompare.hidden = true;
        }
      }
      if (atc) {
        atc.disabled = !variant.available;
        if (atcText) {
          atcText.textContent = variant.available
            ? (atc.getAttribute('data-preorder') === 'true' ? 'PRE-ORDER — LOCK IT IN' : 'ADD TO CART')
            : 'SOLD OUT';
        }
      }
      // reflect variant in URL without reloading
      if (history.replaceState && variant.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', update);
    });
    // preserve preorder intent for the button text
    if (atc && atcText && /PRE-ORDER/i.test(atcText.textContent)) atc.setAttribute('data-preorder', 'true');
    update();

    /* Gallery thumbnails */
    var mainMedia = root.querySelector('[data-main-media]');
    var mainImg = mainMedia ? mainMedia.querySelector('img') : null;
    var thumbs = root.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImg) {
          mainImg.src = thumb.getAttribute('data-full');
          mainImg.removeAttribute('srcset');
        }
        thumbs.forEach(function (t) { t.classList.remove('is-current'); });
        thumb.classList.add('is-current');
      });
    });
  }

  /* -------- Cart: enhance ATC to update header count, then go to cart -------- */
  function initAddToCart() {
    var form = document.querySelector('.pdp__form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // native fallback
      e.preventDefault();
      var btn = form.querySelector('[data-atc]');
      var original = btn ? btn.querySelector('[data-atc-text]').textContent : '';
      if (btn) { btn.disabled = true; btn.querySelector('[data-atc-text]').textContent = 'ADDING…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
        body: new URLSearchParams(new FormData(form)).toString()
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return refreshCartCount();
        })
        .then(function () { window.location.href = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart' : '/cart'; })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.querySelector('[data-atc-text]').textContent = original || 'ADD TO CART'; }
          form.submit(); // fall back to native submit
        });
    });
  }

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.querySelector('[data-cart-count]');
        if (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
        }
      });
  }

  /* -------- Collection sort -------- */
  function initSort() {
    var select = document.querySelector('[data-sort-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* -------- Login / recover toggle -------- */
  function initLogin() {
    var loginWrap = document.querySelector('[data-login-form]');
    var recoverWrap = document.querySelector('[data-recover-form]');
    if (!loginWrap || !recoverWrap) return;
    function show(which) {
      loginWrap.hidden = which !== 'login';
      recoverWrap.hidden = which !== 'recover';
    }
    document.querySelectorAll('[data-show-recover]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); show('recover'); });
    });
    document.querySelectorAll('[data-show-login]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); show('login'); });
    });
    if (window.location.hash === '#recover') show('recover');
  }

  /* -------- Addresses: toggles, delete confirm, country/province -------- */
  function initAddresses() {
    document.querySelectorAll('[data-address-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.getAttribute('data-address-toggle'));
        if (!target) return;
        var open = target.hidden;
        target.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.querySelectorAll('[data-confirm]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (!window.confirm(btn.getAttribute('data-confirm'))) e.preventDefault();
      });
    });
    // Country/province via Shopify's provided helper if present
    if (window.Shopify && window.Shopify.CountryProvinceSelector) {
      document.querySelectorAll('[data-address-country-select]').forEach(function (sel) {
        var id = sel.getAttribute('data-form-id');
        try {
          new window.Shopify.CountryProvinceSelector('AddrCountry_' + id, 'AddrProvince_' + id, {
            hideElement: 'AddrProvinceContainer_' + id
          });
        } catch (err) { /* selector not available */ }
      });
    }
  }

  /* -------- Product recommendations: fetch + inject -------- */
  function initRecommendations() {
    var el = document.querySelector('[data-recommendations]');
    if (!el || !window.fetch) return;
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-recommendations]');
        if (fresh) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* leave the section empty on failure */ });
  }

  /* -------- Scroll reveal: fade + rise sections/elements into view --------
     One-shot IntersectionObserver. Classes are added by JS only, so if JS
     never runs the content stays fully visible (no FOUC / no hidden content). */
  function initReveal() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var targets = [];
    // single elements that reveal on their own
    var singles = document.querySelectorAll(
      '.hero__content, .featured__head, .collection__head, .trust__cell,' +
      '.about-teaser__media, .about-teaser__copy, .capture__copy, .capture__form,' +
      '.pdp__media, .pdp__info, .reviews__aggregate, .story__headline, .story__body,' +
      '.section-heading, .section-kicker, .bogo, .recs .section-heading'
    );
    Array.prototype.forEach.call(singles, function (el) { targets.push(el); });

    // grids whose children stagger in
    var groups = [
      ['.why__grid', ':scope > .why__item'],
      ['.product-grid', ':scope > li'],
      ['.reviews__row', ':scope > .review-card'],
      ['.faq__list', ':scope > .faq__item']
    ];
    groups.forEach(function (g) {
      Array.prototype.forEach.call(document.querySelectorAll(g[0]), function (grid) {
        var kids = grid.querySelectorAll(g[1]);
        Array.prototype.forEach.call(kids, function (kid, i) {
          kid.style.setProperty('--reveal-delay', Math.min(i * 70, 420) + 'ms');
          if (targets.indexOf(kid) === -1) targets.push(kid);
        });
      });
    });

    // drop any target that lives inside another target (parent reveals it) to
    // avoid nested double-fades
    targets = targets.filter(function (el) {
      return !targets.some(function (other) { return other !== el && other.contains(el); });
    });

    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('reveal', 'is-visible'); });
      return;
    }
    targets.forEach(function (el) { el.classList.add('reveal'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* -------- Hero slideshow: cross-fade multiple images -------- */
  function initHeroSlideshow() {
    var wrap = document.querySelector('[data-hero-slides]');
    if (!wrap) return;
    var slides = wrap.querySelectorAll('[data-hero-slide]');
    if (slides.length < 2) return; // one image = static hero
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; // hold on first
    var interval = parseInt(wrap.getAttribute('data-interval'), 10);
    if (!interval || interval < 1500) interval = 5000;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, interval);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initNav();
    initHeroSlideshow();
    initTicker();
    initProduct();
    initAddToCart();
    initSort();
    initLogin();
    initAddresses();
    initRecommendations();
    initReveal();

    // Keep header count fresh when returning to cached pages
    if (document.querySelector('[data-cart-count]')) {
      document.addEventListener('cart:updated', refreshCartCount);
    }
  });
})();
